<template>
  <div class="projects-box">
    <menuBox :step="4"></menuBox>
    <div class="title-box">
      <div class="title">
        <p>Seguro y confiable, protegiendo sus derechos e intereses</p>
        <span>Al elegir nuestra APLICACIÓN de préstamos, no solo podrá disfrutar de servicios rápidos y convenientes,
          sino también sentir la sinceridad y profesionalismo de nuestro equipo. Unamos nuestras manos para crear un
          futuro mejor</span>
      </div>
    </div>
    <div class="projects">
      <img src="../assets/projects.png" alt="">
      <div class="info">
        <div class="left">
          <div class="itemBt">
            Breve descripción
          </div>
          <div class="itemBox">
            <!-- <div class="item">
              <p>número de teléfono :</p>
              <span>Katherine Coleman</span>
            </div> -->
            <div class="item">
              <p>Correo electrónico :</p>
              <span>OnlineElitePortfolio@gmail.com</span>
            </div>
            <div class="item">
              <p>DIRECCIÓN :</p>
              <span>Av. Camilo Henríquez 3692, Puente Alto, Metropolitan Region, Chile</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="bt">Breve descripción</div>
          <div class="title">
            Trabajando junto con instituciones financieras autorizadas y que cumplen con las normas, estamos
            comprometidos a utilizar la tecnología para mejorar la eficiencia de los servicios financieros y brindar a
            una amplia gama de usuarios servicios diversificados de préstamos de crédito personal. La tasa de interés
            diaria es tan baja como 0,02%, puede pedir prestado y pagar en cualquier momento, la operación es simple y
            estamos comprometidos a crear una muy buena experiencia de usuario.<br>

            Como plataforma de préstamos constantemente innovadora, continuamos introduciendo la última tecnología
            financiera para optimizar la experiencia del usuario. A través del análisis de big data y la tecnología de
            inteligencia artificial, podemos evaluar con mayor precisión el estado crediticio y las necesidades de
            préstamos de los usuarios, brindando así servicios de préstamos más personalizados.<br>

            *Innovación continua y liderazgo en la tendencia de la industria.<br>
            *Préstamos de integridad, préstamos para un futuro mejor.<br>
            *Pide prestado y devuélvelo en cualquier momento, ahorrándote preocupaciones y esfuerzos.<br>
            Siempre nos adherimos a un enfoque centrado en el usuario y brindamos servicios de préstamo eficientes y
            convenientes. Ya sea una solicitud en línea o una consulta fuera de línea, nos esforzamos por responder
            rápidamente y manejarla de manera eficiente. Al mismo tiempo, también hemos establecido una línea directa de
            atención al cliente y un sistema de atención al cliente en línea para responder las preguntas y problemas de
            los usuarios en cualquier momento, asegurando que cada usuario pueda sentir un servicio atento.<br>
            *Equipo profesional, servicio considerado.<br>
            *Múltiples métodos de contacto para elegir<br>
            *Seguro y confiable, garantizando la seguridad de sus fondos<br>
            Esperamos cooperar y caminar de la mano con nosotros en las buenas y en las malas. Si tiene alguna idea,
            desea consultar o tiene alguna pregunta, no dude en contactarnos en cualquier momento.<br>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('ความสำเร็จ!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  .title-box {
    background-image: url(../assets/aboutUs.png);
    width: 100%;
    height: 500px;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;

    .title {
      padding: 236px 360px 0;

      p {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 60px;
        color: #2D2D2D;
        line-height: 88px;
      }

      span {
        font-size: 18px;
        color: #4B5257;
        line-height: 28px;
      }
    }
  }
}

.projects {
  padding: 130px 360px;

  img {
    width: 100%;
    margin-bottom: 50px;
  }

  .info {
    display: flex;
    justify-content: space-between;

    .left {
      margin-right: 30px;
      width: 360px;
      overflow: hidden;
      box-sizing: border-box;

      .itemBt {
        width: 100%;
        padding: 24px 34px;
        background: #B4CDF6;
        font-weight: 600;
        font-size: 25px;
        color: #2D2D2D;
      }

      .itemBox {
        padding: 37px;
        background: #F4F4F4;
      }

      .item {
        margin-bottom: 18px;
        padding-bottom: 18px;
        border-bottom: 1px solid #999;

        p {
          font-weight: 600;
          font-size: 18px;
          color: #37393F;
        }

        span {
          font-size: 18px;
          color: #7D7D7D;
        }
      }
    }

    .right {
      flex: 1;

      .bt {
        margin-bottom: 12px;
        font-weight: bold;
        font-size: 40px;
        color: #37393F;
        line-height: 51px;
      }

      .title {
        font-size: 18px;
        color: #7D7D7D;
        line-height: 26px;
      }
    }
  }
}
</style>
